import React, { useState } from "react";
import { Button, Input, Form, Image, Row, Col } from "antd";
import { logo1, signinPopup } from "../../assets/images";
import {
  forgotPassword,
  login,
  twoFactorAuthLogin,
} from "../../redux/actions/Auth/auth.actions";
import { useDispatch, useSelector } from "react-redux";
import { clearMessage } from "../../redux/actions/Message/message.actions";
import { useEffect } from "react";
import styles from "./Login.module.css";
import { COLORS } from "../../config/theme";
import { openNotification } from "../../redux/actions/Notification/notifications.action";
import LoginSocial from "./LoginSocial";
import { TWO_FACTOR_AUTH } from "../../redux/actions/Auth/authTypes";
import { useLocation } from "react-router-dom";

const Login = () => {
  const { pathname } = useLocation();

  const { danger1, primaryDark } = COLORS;

  const dispatch = useDispatch();
  const { message } = useSelector((state) => state.message);
  const { twoFactorAuth, twoFactorEmail } = useSelector((state) => state.auth);
  const [resetPassword, setResetPassword] = useState(false);
  const { Item } = Form;
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const handleFinish = (values) => {
    setIsLoading(true);
    dispatch(login(values))
      .then(() => setIsLoading(false))
      .catch(() => setIsLoading(false));
  };
  const handleTwoFactorAuth = (values) => {
    const data = { ...values, email: twoFactorEmail };
    setIsLoading(true);
    dispatch(twoFactorAuthLogin(data))
      .then(() => setIsLoading(false))
      .catch(() => setIsLoading(false));
  };
  const handleFinishFailed = (err) => {
    console.log(err);
  };
  const handleFinishForgetPassword = (values) => {
    setIsLoading(true);
    dispatch(forgotPassword(values))
      .then(() => {
        openNotification({
          message: "Success!",
          description: "Please check your email",
          icon: "success",
        });
        setIsLoading(false);
        setResetPassword(false);
      })
      .catch(() => setIsLoading(false));
  };
  const handleFinishForgetPasswordFailed = (err) => {
    console.log(err);
  };
  useEffect(() => {
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <div className={styles.main}>
      {pathname !== "/login-page2" && (
        <header className={styles.header}>
          <Row span={24} style={{ height: "100%" }}>
            <Col span={12} style={{}}>
              <img src={logo1} alt="" />
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <button
                onClick={() => {
                  window.open("https://wavecards.com.au/support", "_blank");
                }}
                className={styles.button}
              >
                Contact Us
              </button>
            </Col>
          </Row>
        </header>
      )}
      <div id="home" className="heroBlock">
        <div className={styles.modal}>
          <div
            style={{
              display: "flex",
              height: "-webkit-fill-available",
              width: "-webkit-fill-available",
            }}
          >
            <div className={styles.popImage}>
              <span
                style={{
                  color: "#727272",
                  textAlign: "center",
                  paddingTop: "20%",
                  width: "50%",
                  fontWeight: "700",
                }}
              >
                {pathname === "/login-page2"
                  ? `Welcome to Cards Management Admin Portal`
                  : `Welcome to Wave Cards Management Admin Portal`}
              </span>
              <Image src={signinPopup} preview={false} draggable={false} />
            </div>

            {twoFactorAuth && twoFactorAuth ? (
              <Form
                onFocus={() => dispatch(clearMessage())}
                form={form}
                onFinish={handleTwoFactorAuth}
                onFinishFailed={handleFinishFailed}
                name="loginForm"
                style={{
                  flex: 2,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    position: "relative",
                    marginTop: ".5rem",
                    backgroundColor: "#001529",
                    width: "60%",
                    justifyContent: "center",
                    borderTopRightRadius: 30,
                    borderBottomRightRadius: 30,
                  }}
                >
                  <p
                    style={{
                      color: "white",
                      paddingTop: 5,
                      paddingBottom: 5,
                    }}
                  >
                    Two Factor Auth
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    position: "relative",
                    marginTop: "1rem",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  <p
                    style={{
                      color: "black",
                      paddingTop: 5,
                      paddingBottom: 5,
                      fontWeight: "600",
                    }}
                  >
                    Login Your Account
                  </p>
                </div>
                <div className={styles.formfields}>
                  <>
                    <label>Token</label>
                    <Item
                      hasFeedback
                      name="token"
                      rules={[
                        { required: true, message: "token is required!" },
                      ]}
                    >
                      <Input.Password
                        className="br-8"
                        size="large"
                        style={{
                          borderWidth: 1,
                          borderColor: "#D9D9D9",
                          borderRadius: 12,
                        }}
                      />
                    </Item>
                  </>
                  <Item>
                    <Button
                      className="br-8"
                      style={{
                        background: message ? danger1 : primaryDark,
                        borderColor: message ? danger1 : primaryDark,
                      }}
                      loading={isLoading}
                      type="primary"
                      htmlType="submit"
                      size="large"
                      block
                    >
                      {message ? message : "Verify"}
                    </Button>
                  </Item>
                  <div
                    style={{
                      display: "flex",
                      position: "relative",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      alignContent: "center",
                    }}
                  >
                    <span
                      onClick={() => {
                        dispatch({
                          type: TWO_FACTOR_AUTH,
                          payload: { twoFactorAuth: false, twoFactorEmail: "" },
                        });
                      }}
                      style={{
                        color: "black",
                        paddingTop: 5,
                        paddingBottom: 5,
                        cursor: "pointer",
                      }}
                    >
                      Send Again!
                    </span>
                  </div>
                </div>
              </Form>
            ) : !resetPassword ? (
              <Form
                onFocus={() => dispatch(clearMessage())}
                form={form}
                onFinish={handleFinish}
                onFinishFailed={handleFinishFailed}
                name="loginForm"
                style={{
                  flex: 2,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    position: "relative",
                    marginTop: ".5rem",
                    backgroundColor: "#001529",
                    width: "60%",
                    justifyContent: "center",
                    borderTopRightRadius: 30,
                    borderBottomRightRadius: 30,
                  }}
                >
                  <p
                    style={{
                      color: "white",
                      paddingTop: 5,
                      paddingBottom: 5,
                    }}
                  >
                    Welcome Back
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    position: "relative",
                    marginTop: "1rem",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  <p
                    style={{
                      color: "black",
                      paddingTop: 5,
                      paddingBottom: 5,
                      fontWeight: "600",
                    }}
                  >
                    Login Your Account
                  </p>
                </div>
                <div className={styles.formfields}>
                  <>
                    <label>Email</label>
                    <Item
                      hasFeedback
                      name="email"
                      rules={[
                        { required: true, message: "Email is required!" },
                        {
                          type: "email",
                          message: "Please enter correct Email!",
                        },
                      ]}
                    >
                      <Input
                        size="large"
                        style={{
                          borderWidth: 1,
                          borderColor: "#D9D9D9",
                          borderRadius: 12,
                        }}
                      />
                    </Item>
                  </>
                  <>
                    <label>Password</label>
                    <Item
                      hasFeedback
                      name="password"
                      rules={[
                        { required: true, message: "Password is required!" },
                      ]}
                    >
                      <Input.Password
                        className="br-8"
                        size="large"
                        style={{
                          borderWidth: 1,
                          borderColor: "#D9D9D9",
                          borderRadius: 12,
                        }}
                      />
                    </Item>
                  </>
                  <Item>
                    {message && (
                      <span
                        style={{
                          display: "block",
                          color: danger1,
                          paddingBottom: "0.3rem",
                        }}
                      >
                        {message}
                      </span>
                    )}
                    <Button
                      className="br-8"
                      style={{
                        background: message ? danger1 : primaryDark,
                        borderColor: message ? danger1 : primaryDark,
                      }}
                      loading={isLoading}
                      type="primary"
                      htmlType="submit"
                      size="large"
                      block
                    >
                      {"Login"}
                    </Button>
                  </Item>

                  {pathname !== "/login-page2" && (
                    <div
                      style={{
                        display: "flex",
                        position: "relative",
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        alignContent: "center",
                      }}
                    >
                      <span
                        onClick={() => {
                          setResetPassword(true);
                        }}
                        style={{
                          color: "black",
                          paddingTop: 5,
                          paddingBottom: 5,
                          cursor: "pointer",
                        }}
                      >
                        Forgot Password?
                      </span>
                    </div>
                  )}
                  {pathname !== "/login-page2" && (
                    <div>
                      <LoginSocial isLoading={isLoading}></LoginSocial>
                    </div>
                  )}
                </div>
              </Form>
            ) : (
              <Form
                onFocus={() => dispatch(clearMessage())}
                form={form}
                onFinish={handleFinishForgetPassword}
                onFinishFailed={handleFinishForgetPasswordFailed}
                name="forgotPassword"
                style={{
                  flex: 2,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    position: "relative",
                    marginTop: ".5rem",
                    backgroundColor: "#001529",
                    width: "60%",
                    justifyContent: "center",
                    borderTopRightRadius: 30,
                    borderBottomRightRadius: 30,
                  }}
                >
                  <p
                    style={{
                      color: "white",
                      paddingTop: 5,
                      paddingBottom: 5,
                    }}
                  >
                    Welcome Back
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    position: "relative",
                    marginTop: "1rem",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  <p
                    style={{
                      color: "black",
                      paddingTop: 5,
                      paddingBottom: 5,
                      fontWeight: "600",
                    }}
                  >
                    Reset Password
                  </p>
                </div>
                <div
                  style={{
                    paddingRight: 60,
                    paddingLeft: 60,
                    marginTop: ".5rem",
                  }}
                >
                  <>
                    <label>Email</label>
                    <Item
                      hasFeedback
                      name="email"
                      rules={[
                        { required: true, message: "Email is required!" },
                        {
                          type: "email",
                          message: "Please enter correct Email!",
                        },
                      ]}
                    >
                      <Input
                        size="large"
                        style={{
                          borderWidth: 1,
                          borderColor: "#D9D9D9",
                          borderRadius: 12,
                        }}
                      />
                    </Item>
                  </>

                  <Item>
                    <Button
                      className="br-8"
                      style={{
                        background: message ? danger1 : primaryDark,
                        borderColor: message ? danger1 : primaryDark,
                      }}
                      loading={isLoading}
                      type="primary"
                      htmlType="submit"
                      size="large"
                      block
                    >
                      {message ? message : "Send Email"}
                    </Button>
                  </Item>

                  <div
                    style={{
                      display: "flex",
                      position: "relative",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      alignContent: "center",
                    }}
                  >
                    <p
                      onClick={() => {
                        setResetPassword(false);
                      }}
                      style={{
                        color: "black",
                        paddingTop: 5,
                        paddingBottom: 5,
                        cursor: "pointer",
                      }}
                    >
                      Login
                    </p>
                  </div>
                </div>
              </Form>
            )}
          </div>
        </div>
      </div>
      {pathname !== "/login-page2" && (
        <footer className={styles.footer}>
          <div className={styles.footerTextContainer}>
            <a
              href="https://wavecards.com.au/"
              target="_blank"
              rel="noreferrer"
            >
              <span className={styles.footerText}>WAVE CARDS</span>
            </a>
          </div>
          <div className={styles.footerTextContainer}>
            <a
              href="https://wavecards.com.au/enterprise/"
              target="_blank"
              rel="noreferrer"
            >
              <span className={styles.footerText}>WAVE CARDS ENTERPRISE</span>
            </a>
          </div>
          <div className={styles.footerTextContainer}>
            <a
              href="https://wavecards.com.au/about-us/"
              target="_blank"
              rel="noreferrer"
            >
              <span className={styles.footerText}>ABOUT US</span>
            </a>
          </div>
          <div className={styles.footerTextContainer}>
            <a
              href="https://wavecards.com.au/support/"
              target="_blank"
              rel="noreferrer"
            >
              <span className={styles.footerText}>HELP</span>
            </a>
          </div>
          <div className={styles.footerTextContainer}>
            <a
              href="https://wavecards.com.au/contact/"
              target="_blank"
              rel="noreferrer"
            >
              <span className={styles.footerText}>CONTACT US</span>
            </a>
          </div>
        </footer>
      )}
    </div>
  );
};

export default Login;
